<template>
  <div>
    <div v-if="this.loadingRestrictionList" class="loader">Loading...</div>
    <el-card v-if="!this.loadingRestrictionList" class="machine-card">
      <h1 v-if="canchangeusersaccessforasset == true ">
        Update Permissions For Technician in
        {{ this.propertyname }}
      </h1>
      <br />
      <div v-if="canchangeusersrole == true" style="text-align: center; margin: 40px 0px ">
        <h3>Please choose what role this user will have for the assets in this property:</h3>
<el-dropdown @command="selectRole" trigger="click">
  <el-button type="primary">
   {{selectedRole}}<i class="el-icon-arrow-down el-icon--right"></i>
  </el-button>
  <el-dropdown-menu   slot="dropdown">
      <el-dropdown-item v-for="role in this.allRoles" :command="role" :key="role.roleid">
        {{role.rolename}}
        <p style="  font-style: italic; font-size: 12px; float: right; margin:0;" v-if="role.customrole == false"> default </p>
      </el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>



   <router-link style="margin-left:15px;"  :to="{ path: `/roles` }"><i class="fas fa-pen"></i>Manage roles </router-link>  

  <p style="font-style: italic; color: #02746E;" v-if="this.roleSelected == true"> Press save to set this role for the user </p>
<el-button 
v-if="this.roleSelected == true"
@click.native="setRoleForUser()"
> Save </el-button>

      </div>
 
   <div v-if="canchangeusersaccessforasset == true && this.techMachineRestrictionList.length > 0">

      <div style="text-align: left;">
        <el-button @click="restrictAllAssets()" type="danger">Restrict All</el-button>
        <el-button @click="unrestrictAllAssets()" type="success">Unrestrict All</el-button>
        
      </div>
      <el-table
        :data="this.techMachineRestrictionList"
        border
        class="machine-table"
        id="firstTable"
      >
        <el-table-column align="center" label="Allow Access">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.restricted"
              inactive-color="#13ce66"
              active-color="#ff4949"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column align="center">
          <template slot-scope="scope">
            <el-image class="machine-image" lazy fit="scale-down" :src="scope.row.imageurl[0]">
              <div slot="placeholder" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" label="Machine Name">
          <template slot-scope="scope">{{ scope.row.machinename }}</template>
        </el-table-column>


        <el-table-column align="center" label="Installation Date">
          <template label="Date" slot-scope="scope">
            {{
            scope.row.installdate
            | moment("timezone", $timeZone, "MMM DD YYYY hh:mm A")
            }}
          </template>
        </el-table-column>
      </el-table>
      <br />
      <el-button @click="UpdateMachineRestrictions()" type="primary">Update Restrictions</el-button>
   
      </div> 
    </el-card>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      techMachineRestrictionList: [],
      propertyname: "",
      loadingRestrictionList: false,
      allassetsrestrictionstatus: null,
      allRoles: null,
      roleSelected: false,
      roleId: null,
      selectedRole: null,
      canchangeusersrole: false,
      canchangeusersaccessforasset: false
    };
  },
  mounted() {
    this.loadingRestrictionList = true;
    EventService.getTechMachineRestrictions(
      this.$route.query.propertyid,
      this.$route.params.TechUserId
    ).then(response => {
      this.canchangeusersaccessforasset = response.data.permissions.canchangeusersaccessforasset;
      this.techMachineRestrictionList = response.data.machinelist;
      this.propertyname = response.data.propertyname;
      this.selectedRole = response.data.rolename;
      this.loadingRestrictionList = false;
    });

    EventService.getAllRoles(this.$route.query.propertyid).then( response => {
     this.canchangeusersrole = response.data.permissions.canchangeusersrole;
     this.allRoles = response.data.roles;
    })
  },
  methods: {
    restrictAllAssets() {
      for (let asset of this.techMachineRestrictionList) {
        asset.restricted = true;
      }
    },
    unrestrictAllAssets() {
      for (let asset of this.techMachineRestrictionList) {
        asset.restricted = false;
      }
    },
    UpdateMachineRestrictions() {
      let machinerestrictionsobject = {};
      let machineids = [];
      for (let machine of this.techMachineRestrictionList) {
        if (machine.restricted == true) {
          machineids.push(machine.machineid);
        }
      }
      machinerestrictionsobject.machineids = machineids;
      EventService.UpdateTechMachineRestrictions(
        this.$route.query.propertyid,
        this.$route.params.TechUserId,
        machinerestrictionsobject
      )
        .then(response => {
          this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Restrictions have been updated"
          });
        }) 
        .catch(error => {
            console.log(error);
        });
    },
    selectRole(role){
      this.selectedRole = role.rolename;
      this.roleSelected = true;
      this.roleId = role.roleid;
    },
    setRoleForUser(){
          EventService.editRoleForUser( this.$route.query.propertyid, this.$route.params.TechUserId, this.roleId ).then( () => {
                  this.$store.dispatch("addNotification", {
                  type: "success",
                  Message: "Role has been updated"
                });
                this.roleSelected = false;
          })
          .catch(error => {
                console.log(error);
                this.roleSelected = false;
        });
    }
  },
};
</script>

<style scoped>
.machine-card {
  margin: 5%;
  padding: 5%;
  max-width: 100%;
}
h1{
  text-align: center;
}
.machine-image {
  text-align: center;
  height: 40px;
  width: 100%;
  border: 0px;
}
@media screen and (max-width: 700px) {
  .machine-card {
    padding: 0;
    margin: 0;
    width: 100%;
  }
}
</style>
